module.exports = __webpack_public_path__ + "static/media/financebanner@3x.d120de74.png";